import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-megapack-bg border-t border-megapack-section py-10 md:py-16 px-4 md:px-6" data-id="element-88">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-89">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-90">
          <div className="flex flex-col mb-4" data-id="element-91">
            <span className="text-megapack-cyan font-display text-3xl font-bold leading-none" data-id="element-92">
              💻 MEGA PACK™
            </span>
            <span className="text-megapack-gray text-sm font-semibold tracking-widest uppercase" data-id="element-93">
              Informática 2026
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-megapack-gray mt-8" data-id="element-94">
            <a href="mailto:soporte.megapack@gmail.com" className="hover:text-megapack-cyan transition-colors" data-id="element-95">
              📧 soporte.megapack@gmail.com
            </a>
            <a href="#" className="hover:text-megapack-cyan transition-colors" data-id="element-96">
              📲 @megapack.info
            </a>
            <a href="#" className="hover:text-megapack-cyan transition-colors" data-id="element-97">
              🌐 www.megapackinformatica.com
            </a>
          </div>
        </div>

        <div className="w-full h-px bg-megapack-cyan/10 mb-12" data-id="element-98" />

        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-megapack-gray leading-relaxed" data-id="element-99">
          <p data-id="element-100">
            © MEGA PACK™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción sin autorización expresa.
          </p>
          <p data-id="element-101">
            MEGA PACK™ es un producto digital de contenido educativo para
            estudiantes universitarios. No reemplaza la cursada oficial ni
            garantiza resultados académicos específicos. Los resultados dependen
            del compromiso y dedicación de cada estudiante.
          </p>
        </div>
      </div>
    </footer>;
};